import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import VideoPlayer from './videojswithhls/VideoPlayerJsWithHls';

// TODO: Use VideoDto
export interface Video {
  id: string;
  status: string;
  title: string;
  description?: string;
  image_url?: string;
  playlist_url?: string;
  original_video_url?: string;
  created_at: string;
  updated_at: string;
}

// TODO: Use CompanyDto
interface Company {
  id: string;
  status: string;
  company_name: string;
  company_description: string;
  company_image?: string;
  intro_video?: Video;
  outro_video?: Video;
}

// TODO: Use PlaylistDto
interface DistrictPlaylist {
  id: string;
  status: string;
  playlist_name: string;
  playlist_url?: string;
  created_at: string;
  district_name: string;
}

const VideoPageVideoHls = () => {

  const { districtId, videoId } = useParams();
  const [video, setVideo] = useState<DistrictPlaylist | null>(null);
  const backendApiUrl = `${process.env.NEXT_PUBLIC_BACKEND_API_URL}`;

  useEffect(() => {
    // Fetch video URL
    fetch(`${backendApiUrl}/api/playlists/${videoId}`)
      .then(response => response.json())
      .then(data => setVideo(data))
      .catch(error => console.error('Error fetching video URL:', error));

  }, [districtId, videoId]);

  const videoOptions = {
    autoplay: true,
    sources: [
      {
        src: video?.playlist_url ?? '',
        type: 'application/x-mpegURL'
      }
    ]
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="max-w-xl w-full shadow-lg rounded-lg bg-white p-6">
        {video && (
          <>
            <h1 className="text-2xl font-bold text-center mb-4">Video name: {video.playlist_name}</h1>

            <div className="mb-4 text-center">
              <h2 className="text-xl font-bold">District: {video.district_name}</h2>
              <p></p>
            </div>
            <div className="aspect-w-16 aspect-h-9">
              <VideoPlayer
                options={videoOptions}
              />
            </div>
          </>
        )
        }
      </div>
    </div>
  );
};

export default VideoPageVideoHls;
